import { useEffect, useState } from "react";

const navLinks = [
  { label: "About", href: "#about" },
  { label: "Built", href: "#built" },
  { label: "Results", href: "#results" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Services", href: "#services" },
  { label: "How I Work", href: "#how-i-work" },
];

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMobileOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background/95 backdrop-blur-md border-b border-border" : "bg-transparent"
      }`}
    >
      <div className="content-max flex items-center justify-between h-16 md:h-20">
        <a href="#" className="flex items-center gap-2.5 font-headline text-xl md:text-2xl text-foreground tracking-tight">
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" className="shrink-0">
            <defs>
              <linearGradient id="bar-grad" x1="0" y1="1" x2="0" y2="0">
                <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.2"/>
                <stop offset="100%" stopColor="#3b82f6" stopOpacity="0.8"/>
              </linearGradient>
            </defs>
            <rect x="3" y="18" width="6" height="7" rx="1.2" fill="url(#bar-grad)" stroke="#3b82f6" strokeWidth="0.6" strokeOpacity="0.25"/>
            <rect x="11" y="13" width="6" height="12" rx="1.2" fill="url(#bar-grad)" stroke="#3b82f6" strokeWidth="0.6" strokeOpacity="0.35"/>
            <rect x="19" y="3" width="6" height="22" rx="1.2" fill="url(#bar-grad)" stroke="#3b82f6" strokeWidth="0.6" strokeOpacity="0.5"/>
            <rect x="3" y="18" width="6" height="1.5" rx="0.8" fill="#3b82f6" opacity="0.4"/>
            <rect x="11" y="13" width="6" height="1.5" rx="0.8" fill="#3b82f6" opacity="0.6"/>
            <rect x="19" y="3" width="6" height="1.5" rx="0.8" fill="#3b82f6" opacity="0.8"/>
          </svg>
          Eric Taylor
        </a>

        {/* Desktop */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleClick(e, link.href)}
              className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-200 font-body"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={(e) => handleClick(e, "#contact")}
            className="text-sm font-medium bg-primary text-primary-foreground px-5 py-2.5 rounded-md hover:opacity-90 transition-opacity"
          >
            Get in Touch
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden text-foreground"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            {mobileOpen ? (
              <path d="M18 6L6 18M6 6l12 12" />
            ) : (
              <path d="M3 12h18M3 6h18M3 18h18" />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-background/98 backdrop-blur-md border-b border-border pb-6 px-6">
          <div className="flex flex-col gap-4 pt-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleClick(e, link.href)}
                className="text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={(e) => handleClick(e, "#contact")}
              className="text-sm font-medium bg-primary text-primary-foreground px-5 py-2.5 rounded-md text-center hover:opacity-90 transition-opacity"
            >
              Get in Touch
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
